<template>
  <div id="app">
    <b-navbar tag="header" class="shadow" toggleable="md"
              style="z-index: 10"
              type="light" variant="success">
      <b-navbar-brand :to="{ name: 'home' }">
        <img src="@/assets/favicon-black.svg" :alt="$t('app.name')"
             class="d-inline-block align-top mr-md-2" />
        <span class="d-none d-md-inline">{{ $t('app.name') }}</span>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item :to="{ name: 'home' }">{{ $t('menu.page.home') }}</b-nav-item>
          <b-nav-item :to="{ name: 'statistics' }">{{ $t('menu.page.statistics') }}</b-nav-item>
          <b-nav-item :to="{ name: 'regions' }">{{ $t('menu.page.regions') }}</b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown :text="$t('menu.dropdown.region')" right>
            <b-dropdown-item v-for="region in $root.countries" :key="'menu-language-' + region"
                             @click="() => $store.commit('setCurrentRegion', region)"
                             :active="region === $store.state.currentRegion">
              {{ $t('region.' + region) }}
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown :text="$t('menu.dropdown.language')" right>
            <b-dropdown-item v-for="(name, lang) in {sv: 'Svenska', en: 'English'}" :key="lang"
                             @click="() => $store.dispatch('changeLocale', lang)"
                             :active="$store.state.currentLocale === lang">
              {{ name }}
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <CookieConsentBanner />

    <b-container class="py-4">
      <router-view />
    </b-container>

    <b-navbar tag="footer" id="footer" type="light" variant="success" class="flex-column flex-md-row">
      <b-navbar-nav>
        <b-nav-text>
          &copy; {{ $t('app.copyright') }}<br/>
          <small>Favicon by <a href="http://www.freepik.com/" title="Freepik">Freepik</a></small>
        </b-nav-text>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-text class="text-center">{{ $t('text.disclaimer') }}</b-nav-text>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
import CookieConsentBanner from '@/components/CookieConsentBanner'

export default {
  name: 'App',
  components: { CookieConsentBanner },
  metaInfo () {
    return {
      titleTemplate: '%s | ' + this.$t('app.name'),
      htmlAttrs: {
        lang: this.$root.$i18n.locale
      },
      meta: [
        { name: 'application-name', content: this.$t('app.name') },
        { name: 'theme-color', content: '#e1e71b' },
        { name: 'copyright', content: this.$t('app.copyright') },
        { name: 'language', content: this.$root.$i18n.locale },
        { name: 'keywords', content: this.$t('app.keywords') },
        { name: 'twitter:card', content: 'summary' },
        { name: 'twitter:site', content: '@02JanDal' },
        { name: 'twitter:title', content: this.$t('app.name') },
        { name: 'twitter:description', content: this.$t('app.description') },
        { name: 'twitter:image',
          content: require('url-loader!@/assets/twitter-card-image.svg.png') }
      ],
      link: [
        { rel: 'alternate', href: '/sv' + this.$route.fullPath, hreflang: 'sv' },
        { rel: 'alternate', href: '/en' + this.$route.fullPath, hreflang: 'en' }
      ]
    }
  }
}
</script>

<style lang="scss">
  #app {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    justify-content: space-between;

    > .container {
      flex-grow: 1;
    }
  }

  .navbar.bg-success {
    background-color: #e1e71b !important;
  }
  .navbar-brand img {
    height: 30px;
  }
</style>
